<template>
  <page-wrapper background="/static/img/anniversary/page-roadmap/bg.png" :swiper="swiper" :hasDownBtn="true">
    <img class="main-roadmap ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-roadmap/历程.png" />
    <img class="main-image ani" swiper-animate-effect="animate__fadeIn" src="/static/img/anniversary/page-roadmap/shape02.png" />
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'

export default {
  components: { PageWrapper },
  props: [
    'swiper'
  ]
}
</script>
<style lang="less" scoped>
.page-wrapper {
  .main-roadmap {
    position: absolute;
    left: 50vw;
    margin-left: -41.865vw;
    top: 8vw;
    width: 83.73vw;
    height: 97.86666667vw;
    z-index: 99;
  }

  .main-image {
    position: absolute;
    left: 50vw;
    margin-left: -36.8vw;
    bottom: 5.3vw;
    width: 73.6vw;
    height: 74.93333333vw;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?717d97ff